import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as actions from '../actions';
import {catchError, mergeMap, switchMap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {OutletService} from 'app/services';
import {OutletProfile} from 'app/models';

@Injectable()
export class OutletProfileEffects {
  constructor(
    private actions$: Actions,
    private outletService: OutletService
  ) {}

  loadPosts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadOutletProfile),
      mergeMap(({ outletId }) =>
        this.getOutletContactDetails$(outletId).pipe(
          switchMap((response) => [
            actions.loadOutletProfileSuccess({
              outletContactProfile: new OutletProfile({
                id: response.id,
                name: response.name,
                description: response.description,
                emailAddress: response.emailAddress,
                webSiteUrl: response.website,
                twitterUrl: response.twitter,
                linkedInUrl: response.linkedIn,
                youTubeUrl: response.youTube,
                imageUrl: response.imageUrl,
                geoScore: response.influenceScore,
                myCompanyStats: response.myCompanyStats,
              }),
            }),
          ]),
          catchError((err) =>
            of(actions.loadOutletProfileError({ payload: err }))
          )
        )
      )
    )
  );

  getOutletContactDetails$(id): Observable<any> {
    return this.outletService.getOutletById(id);
  }
}
